module.exports = __webpack_public_path__ + "static/media/childrens.a6112720.png";